var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.810822,
    y: 0.243164,
    width: 24.3243,
    height: 24.3243,
    rx: 4.86486,
    fill: "#336AE9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_290_1118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_290_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.356 19.7969C7.9005 19.7969 7.51119 19.6352 7.18806 19.312C6.86481 18.9889 6.70319 18.5995 6.70319 18.144V5.85604C6.70319 5.39854 6.86481 5.00754 7.18806 4.68304C7.51119 4.35854 7.9005 4.19629 8.356 4.19629H14.1977C14.4235 4.19629 14.6386 4.24079 14.8429 4.32979C15.0474 4.41879 15.226 4.5396 15.3786 4.69223L18.8078 8.12141C18.9604 8.27404 19.0812 8.4526 19.1702 8.6571C19.2592 8.86148 19.3037 9.07654 19.3037 9.30229V18.144C19.3037 18.5995 19.1415 18.9889 18.817 19.312C18.4925 19.6352 18.1015 19.7969 17.644 19.7969H8.356ZM14.0314 8.6046C14.0314 8.83585 14.1114 9.03141 14.2712 9.19129C14.4311 9.35116 14.6267 9.4311 14.8579 9.4311H17.644L14.0314 5.85604V8.6046ZM12.3751 14.308V16.0454C12.3751 16.2225 12.4351 16.3709 12.5552 16.4907C12.6755 16.6105 12.8245 16.6705 13.0022 16.6705C13.1799 16.6705 13.3281 16.6105 13.4468 16.4907C13.5656 16.3709 13.6249 16.2225 13.6249 16.0454V14.308H15.3751C15.5521 14.308 15.7005 14.2479 15.8204 14.1276C15.9401 14.0074 16 13.8584 16 13.6808C16 13.503 15.9401 13.3548 15.8204 13.236C15.7005 13.1173 15.5521 13.0579 15.3751 13.0579H13.6249V11.308C13.6249 11.1309 13.5649 10.9824 13.4447 10.8627C13.3245 10.7428 13.1755 10.6829 12.9977 10.6829C12.8201 10.6829 12.6719 10.7428 12.5532 10.8627C12.4344 10.9824 12.3751 11.1309 12.3751 11.308V13.0579H10.6249C10.4479 13.0579 10.2995 13.118 10.1796 13.2383C10.0599 13.3584 10 13.5074 10 13.6851C10 13.8629 10.0599 14.0111 10.1796 14.1299C10.2995 14.2486 10.4479 14.308 10.6249 14.308H12.3751Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCard);
export default __webpack_public_path__ + "static/media/project_card.4c4f93da023d50faecf896b7ac8e671e.svg";
export { ForwardRef as ReactComponent };